import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { AllocationPage } from '../pages/AllocationPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/allocation')({
  component: Allocation,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Allocation() {
  return (
    <MainLayout>
      <AllocationPage />
    </MainLayout>
  )
}
